import { AlertsTab, type AlertsTabProps } from "@components/job_alerts/alerts_tab.tsx";
import { SearchTab, type SearchTabProps } from "@components/job_search/search_tab.tsx";
import { SavedTab, type SavedTabProps } from "@components/saved_jobs/saved_tab.tsx";

type Props =
  | ({ tab: "search" } & SearchTabProps)
  | ({ tab: "saved" } & SavedTabProps)
  | ({ tab: "alerts" } & AlertsTabProps);

const Jobs = (props: Props) => {
  switch (props.tab) {
    case "alerts":
      return <AlertsTab {...props} />;
    case "saved":
      return <SavedTab {...props} />;
    default:
      return <SearchTab {...props} />;
  }
};

export default Jobs;
